<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on: tooltip}">
                <v-btn icon v-on="tooltip">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>

      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.delegationRate.groupDelegationRate.formTitle") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field :label="$t('global.name') + '*'" :rules="delegationRateGroup.rules().name" v-model="delegationRateGroup.name"> </v-text-field>
            <v-text-field :label="$t('global.description')" :rules="delegationRateGroup.rules().description" v-model="delegationRateGroup.description">
            </v-text-field>
            <delegation-rate-group-select
              :except-group-id="delegationRateGroup.id"
              :label="$t('settings.delegationRate.groupDelegationRate.parentGroup')"
              :model.sync="delegationRateGroup.parent_group_id"
              :rules="delegationRateGroup.rules().parent_group_id"
              ref="groupselect"
            >
            </delegation-rate-group-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import DelegationRateItem from "src/models/settings/delegationRateItem";
import UserGroup from "src/models/settings/group";
import DelegationRateGroupSelect from "src/components/CustomInputComponents/DelegationRateGroupSelect.vue";

export default {
  name: "GroupDelegationFormDialog",
  components: {
    DelegationRateGroupSelect
  },
  props: {
    id: {
      required: false,
      default: null
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        if (this.id != null) {
          this.delegationRateGroup.load(this.id);
        }
        if (typeof this.$refs.groupselect !== "undefined") {
          if (typeof this.$refs.groupselect.load() !== "undefined") {
            this.$refs.groupselect.load();
          }
        }
      }
    }
  },
  data: () => {
    return {
      delegationRateGroup: new UserGroup(),
      dialog: false,
      formValid: true
    };
  },
  created() {},
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.delegationRateGroup
          .save()
          .then(() => {
            if (this.id == null) {
              this.delegationRateGroup = new DelegationRateItem();
            }
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved")
            });
            this.$emit("saved");
            this.dialog = false;
          })
          .catch(resp => {
            console.log(resp.response);
            if (resp.response.data.status === "RECURSION") {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("settings.delegationRate.groupDelegationRate.canNotSaveLoop"),
                color: "error"
              });
            }
          });
      }
    }
  }
};
</script>

<style scoped></style>
